const mainColorVariants = {
  100: '',
  90: '#0D3248',
  80: '#0F4A6C',
  70: '#106193',
  60: '#0F77BC',
  50: '#34A6F3',
  40: '#88CCFB',
  30: '#B4DFFD',
  25: '#E7EDF5',
  20: '#E2ECF9',
  10: '#EFF8FF',
} as const;

const accentColorVariants = {
  100: '#A60832',
  90: '#D40742',
  80: '#FA1056',
  70: '#FD3A78',
  60: '#FF6699',
  50: '#FF8BB4',
  40: '#FFB0CD',
  30: '#FFCDE0',
  20: '#FFDDEA',
  10: '#FCEDF1',
} as const;

const purpleColorVariants = {
  100: '',
  90: '',
  80: '',
  70: '#853F71',
  60: '',
  50: '#BD63A4',
  40: '',
  30: '',
  20: '',
  10: '#F5E3F0',
} as const;

const neutralColorVariants = {
  100: '#4E4D4D',
  90: '#616060',
  80: '#747373',
  70: '#878686',
  60: '#9A9A9A',
  50: '#A0A0A0',
  40: '#C0C0C0',
  30: '#D3CECE',
  25: '#DCDEE8',
  20: '#ECECF2',
  10: '#F4F7FB',
} as const;

const errorColorVariants = {
  100: '#220B0A',
  90: '#6A1815',
  80: '#6A1815',
  70: '#8E1F1A',
  60: '#B3261E',
  50: '#CB3E2F',
  40: '#DB5547',
  30: '#EC766F',
  20: '#F29B97',
  10: '#FCE4E3',
} as const;

const successColorVariants = {
  100: '#0B1715',
  90: '#193732',
  80: '#26584E',
  70: '#32796B',
  60: '#3D9C89',
  50: '#4BBCA4',
  40: '#6BCAB6',
  30: '#8CD7C7',
  20: '#ADE4D8',
  10: '#CFF0E9',
} as const;

const warningColorVariants = {
  100: '#422E07',
  90: '#6D4A0A',
  80: '#99670B',
  70: '#C7830B',
  60: '#F59E0B',
  50: '#F8B036',
  40: '#FBC261',
  30: '#FDD38D',
  20: '#FEE5BA',
  10: '#FFF6E7',
} as const;

const mainColors = {
  BLUE: mainColorVariants[60],
  BLACK: '#171A1F',
  WHITE: '#FFFFFF',
  PINK: accentColorVariants[60],
} as const;

const hexOpacities = {
  10: '1A',
  20: '33',
  50: '80',
} as const;

const Colors = {
  ...mainColors,
  MAIN_VARIANTS: mainColorVariants,
  ACCENT_VARIANTS: accentColorVariants,
  PURPLE_VARIANTS: purpleColorVariants,
  NEUTRAL_VARIANTS: neutralColorVariants,
  ERROR_VARIANTS: errorColorVariants,
  SUCCESS_VARIANTS: successColorVariants,
  WARNING_VARIANTS: warningColorVariants,
  HEX_OPACITIES: hexOpacities,
} as const;

export default Colors;
